<h2 mat-dialog-title>Add New Worker</h2>

<form [formGroup]="editForm" (ngSubmit)="onEditFormSubmit(editForm.value)">
  <mat-dialog-content>
    <div class="row">
      <mat-form-field appearance="fill">
        <mat-label>First Name</mat-label>
        <input matInput formControlName="firstName" required>
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field appearance="fill">
        <mat-label>Last Name</mat-label>
        <input matInput formControlName="lastName" required>
      </mat-form-field>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="close()">Cancel</button>
    <button mat-raised-button color="primary" type="submit" [disabled]="!editForm.valid || (operationInProg$ | async)">
      <span *ngIf="!(operationInProg$ | async)">Save</span>
      <mat-spinner *ngIf="operationInProg$ | async" diameter="20"></mat-spinner>
    </button>
  </mat-dialog-actions>
</form> 